import { render, staticRenderFns } from "./search-texts.vue?vue&type=template&id=9cb168ea"
import script from "./search-texts.vue?vue&type=script&lang=ts"
export * from "./search-texts.vue?vue&type=script&lang=ts"
import style0 from "./search-texts.vue?vue&type=style&index=0&id=9cb168ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports